import ViewProviders from './ViewProviders';

export default ViewProviders;
